// OData query shapes for AIAgentSchedule (`ai/schedule`).
//
// Sharing fields (`accessControl`, `collaborators`) and `canManage` are NOT
// OData EDM properties — never put them in `$select` or the query 400s.
// They travel on POST/PUT/PATCH and on GET-by-id without `$select`
// (JSON serializer). See AI Agent Schedule AccessControl UX guide.

export default {
  // Never `$expand=aiAgent` on schedule reads — the expand can overwrite root
  // `id` / `name` with the agent's (see Launchpad jobs entityType + useWorkAgents).
  // Resolve agent name/avatar client-side from `aiAgentId` instead.
  paged: {
    select:
      'id,name,instructions,isActive,aiAgentId,chatThreadId,executionMode,frequency,frequencyValue,startDate,nextExecutionDate,lastExecutionDate,maxConcurrentExecutions,ownerUserId',
    searchSelect: ['name', 'instructions'],
    orderBy: 'nextExecutionDate asc',
  },
  // `userTaskId` + `documents` ride along so PUT (full update, UX §4.3) can
  // preserve them even though the form doesn't manage them.
  item: {
    select:
      'id,name,instructions,isActive,aiAgentId,chatThreadId,userTaskId,documents,executionMode,frequency,frequencyValue,startDate,nextExecutionDate,lastExecutionDate,maxConcurrentExecutions,timeRules,ownerUserId',
  },
  itemDetail: {
    select:
      'id,name,instructions,isActive,aiAgentId,chatThreadId,userTaskId,documents,executionMode,frequency,frequencyValue,startDate,nextExecutionDate,lastExecutionDate,maxConcurrentExecutions,timeRules,ownerUserId,creator,modifier,created,updated',
  },
};
